<mat-form-field
  class="app-multi-select"
  [ngClass]="styleClass"
  [ngStyle]="style"
  appearance="outline"
  [class.app-multi-select--open]="isOpen"
  subscriptSizing="dynamic"
  >
  <mat-select
    [id]="id"
    [disabled]="disabled"
    [value]="value"
    [panelClass]="panelClasses"
    multiple
    (selectionChange)="onMatSelectionChange($event)"
    (openedChange)="handleOpenedChange($event)"
    (focus)="handleFocus($event)"
    (blur)="handleBlur($event)"
    [placeholder]="placeholder"
    >
    <mat-select-trigger>
      @if (isValueEmpty) {
        <span class="app-multi-select__trigger-placeholder">{{ placeholder }}</span>
      } @else {
        @if (displayChips) {
          <span class="app-multi-select__chips" (click)="$event.stopPropagation()" (mousedown)="$event.stopPropagation()">
            @for (v of chipValues; track v) {
              <span class="app-multi-select__chip">
                <span class="app-multi-select__chip-label">{{ resolveLabelForSelectedValue(v) }}</span>
                <button
                  type="button"
                  class="app-multi-select__chip-remove"
                  aria-label="Remove"
                  (click)="removeSelectedValue(v, $event)"
                  >
                  <i class="pi pi-times" aria-hidden="true"></i>
                </button>
              </span>
            }
            @if (chipOverflowCount > 0) {
              <span class="app-multi-select__chip-overflow">...</span>
            }
          </span>
        } @else {
          {{ triggerText }}
        }
      }
    </mat-select-trigger>

    @if (headerTemplate?.templateRef || filter || showSelectAll) {
      <div
        class="app-multi-select__header"
        (click)="$event.stopPropagation()"
        (mousedown)="$event.stopPropagation()"
        >
        <div class="app-multi-select__header-row">
          @if (headerTemplate?.templateRef) {
            <div class="app-multi-select__header-left">
              <ng-container *ngTemplateOutlet="headerTemplate?.templateRef"></ng-container>
            </div>
          }
          @if (filter || showSelectAll) {
            <div class="app-multi-select__header-right">
              @if (showSelectAll) {
                <div class="app-multi-select__select-all-wrap">
                  <label
                    class="app-multi-select__select-all"
                    (click)="$event.stopPropagation()"
                    (mousedown)="$event.stopPropagation()"
                    >
                    <input
                      #selectAllCheckbox
                      type="checkbox"
                      class="app-multi-select__select-all-checkbox"
                      [checked]="isAllDisplayedSelected"
                      [disabled]="disabled || selectableDisplayedOptions.length === 0"
                      (change)="toggleSelectAll()"
                      aria-label="Select all"
                      />
                  </label>
                </div>
              }
              @if (filter) {
                <div
                  class="app-multi-select__search"
                  (click)="$event.stopPropagation()"
                  (mousedown)="$event.stopPropagation()"
                  >
                  <input
                    matInput
                    type="text"
                    placeholder="Filter"
                    [(ngModel)]="filterText"
                    [ngModelOptions]="{ standalone: true }"
                    (keydown)="$event.stopPropagation()"
                    />
                  @if (filterText && filterText.length > 0) {
                    <button
                      type="button"
                      class="app-multi-select__filter-clear"
                      (click)="filterText = ''"
                      aria-label="Clear filter"
                      >
                      <i class="pi pi-times" aria-hidden="true"></i>
                    </button>
                  }
                </div>
              }
            </div>
          }
        </div>
      </div>
    }

    <div class="app-multi-select__scroll">
      @if (virtualScroll) {
        <cdk-virtual-scroll-viewport
          class="app-multi-select__viewport"
          [itemSize]="itemSizePx"
          [style.height.px]="viewportHeightPx"
          >
          <mat-option
            *cdkVirtualFor="let option of displayedOptions"
            [value]="getOptionValue(option)"
            [disabled]="isOptionDisabled(option)"
            >
            {{ getOptionLabel(option) }}
          </mat-option>
        </cdk-virtual-scroll-viewport>
      } @else {
        @for (option of displayedOptions; track option) {
          <mat-option
            [value]="getOptionValue(option)"
            [disabled]="isOptionDisabled(option)"
            >
            {{ getOptionLabel(option) }}
          </mat-option>
        }
      }


      @if (displayedOptions.length === 0) {
        <mat-option disabled>{{ emptyLabel }}</mat-option>
      }
    </div>

    @if (footerTemplate?.templateRef) {
      <div
        class="app-multi-select__footer"
        (click)="$event.stopPropagation()"
        (mousedown)="$event.stopPropagation()"
        >
        <ng-container *ngTemplateOutlet="footerTemplate?.templateRef"></ng-container>
      </div>
    }
  </mat-select>

  @if (showClear && !disabled && !isValueEmpty) {
    <button
      matSuffix
      type="button"
      class="app-multi-select__suffix-clear"
      (click)="clear($event)"
      aria-label="Clear selection"
      >
      <i class="pi pi-times" aria-hidden="true"></i>
    </button>
  }
</mat-form-field>

